import {RECEIVE_SITEMAP_DATA} from "../actions/sitemapActions";

const initialState = {};
export default function sitemapReducer(state = initialState, action) {
    switch (action.type) {
        case RECEIVE_SITEMAP_DATA:
            return {
                ...state,
                sitemap: [...action.payload]
            };
        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/reducers/sitemapReducer.js